const generateId = () => {
    const hash = Math.random().toString(36).substring(2);
    return hash;
};
export default generateId;
